import Header from "./_header";
import Sidebar from "./_aside";
import {useDispatch, useSelector} from "react-redux";
import {userService} from "../services/UserService";
import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {ReactComponent as HomeSvg} from "../assets/icons/home.svg";
import Loader from "../components/Loader";
import {isMobile, setSearchString} from "../actions/main";
import {InputText} from "primereact/inputtext";
import {SET_IS_MOBILE} from "../actions/types";
import {Button} from "primereact/button";


export default function CrmLayout(props) {

    const [BM, setBM] = useState(false);
    const headBtns = useSelector((state) => state.headBtns)
    const [updateUserStatus, setUpdateUserStatus] = useState(false);
    const [updatingUser, setUpdatingUser] = useState(false);
    const [search, setSearch] = useState('');
    const [width, setWidth] = useState(window.innerWidth);

    const dispatch = useDispatch()
    let navigation = useNavigate();

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    useEffect(() => {
        if (width <= 768) {
            dispatch(isMobile(true))
        } else {
            dispatch(isMobile(false))
        }
    }, [width]);

    const userData = useSelector(function (state) {
        return state.auth.userData
    });

    const pageTitle = useSelector((state) => {
        return state.pageTitle
    })

    const searchHandler = useSelector((state) => {
        return state.searchHandler
    })

    const searchString = useSelector((state) => {
        return state.searchString
    })

    const createButton = useSelector((state) => {
        return state.createButton
    })

    const breadcrumbs = useSelector((state) => {
        return state.breadcrumbs
    })

    const isLogout = useSelector(function (state) {
        return state.auth.logout
    });

    if (isLogout) {
        navigation('/login');
    }

    if (!userData) {
        userService.UpdateInfo()
    }

    // useEffect(() => {
    //     if(search) {
    //         dispatch(setSearchString(search))
    //     }
    // }, [search]);

    return (

        userData ?
            <div className={'page-wrapper compact-wrapper'}>
                <Header/>
                <div className="page-body-wrapper">
                    <Sidebar/>


                    <div className="page-body">
                        <div className="container-fluid">

                            {pageTitle &&
                                <div className="page-title">

                                    <div className="row">
                                        <div className="col-12 col-sm d-flex align-items-center">
                                            <h3>{pageTitle}</h3>
                                            {createButton &&
                                                <Link
                                                    className={'btn m-l-30 btn-success btn-block flex-shrink-0 btn-pill d-none d-md-block'}
                                                    to={createButton}>
                                                    <span className="fa fa-plus-circle"></span> Добавить
                                                </Link>
                                            }
                                        </div>
                                        <div className="col-12 col-sm-4">

                                            <div className="d-flex gap-2 align-items-center">

                                                {headBtns && <>


                                                    {headBtns.map((btn, index) => {
                                                        return (<Button key={index} className={btn.className} icon={btn.icon} label={btn.text}
                                                                        text={btn.className && btn.className.includes('p-button-text')} 
                                                                        onClick={btn.handler} style={{flexShrink: 0}}/>)
                                                    })}

                                                </>}

                                                {searchHandler &&
                                                    <form onSubmit={(e) => searchHandler(e, searchString)}
                                                          className={'theme-form d-flex w-100'}>

                                                        <div className="input-group ">
                                                            <InputText className={'btn-pill form-control'}
                                                                       value={searchString}
                                                                       placeholder={'Поиск по разделу'}
                                                                       onChange={(e) => {
                                                                           dispatch(setSearchString(e.target.value))
                                                                       }
                                                                       }/>

                                                            {/*<input type="search" className={'form-control btn-pill p-3'}*/}
                                                            {/*       placeholder={'Поиск по телефону, имени, email, id...'}*/}
                                                            {/*       // value={search}*/}
                                                            {/*       onChange={(e) => dispatch(setSearchString(e.target.value))}/>*/}

                                                            <button type={'submit'}
                                                                    className={'btn btn-primary btn-pill '}>
                                                                <span className="fa fa-search"></span>
                                                            </button>
                                                        </div>

                                                    </form>
                                                }


                                                {/*<ol className="breadcrumb" >*/}
                                                {/*    <li className="breadcrumb-item">*/}
                                                {/*        <Link to={'/'}>*/}
                                                {/*            <HomeSvg/>*/}
                                                {/*        </Link>*/}
                                                {/*    </li>*/}
                                                {/*    {breadcrumbs.map((el, i) => {*/}
                                                {/*        return (*/}
                                                {/*            <li key={'bread-' + i} className="breadcrumb-item active">*/}
                                                {/*                <Link to={el.link}>*/}
                                                {/*                    {el.label}*/}
                                                {/*                </Link>*/}
                                                {/*            </li>*/}
                                                {/*        )*/}
                                                {/*    })}*/}

                                                {/*</ol>*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }


                            {props.children}
                        </div>
                    </div>
                </div>


            </div>
            : <Loader/>
    )
}